import React from 'react';
import { InputNumber } from 'antd';

const NumberInput = ({ value, onChange, factor = 1, parse = x => x, ...props }) => (
  <InputNumber
    {...props}
    value={value != null ? value / factor : value}
    onChange={v => onChange(parse(v != null ? v * factor : v))}
  />
);

export default NumberInput;
